import {AfterViewChecked, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Saisine, SaisineStatus} from './saisine.model';
import {SaisineService} from './saisine.service';
import {Principal} from '../../shared/auth/principal.service';
import {Rejection} from '../rejection/rejection.model';
import {UtilsService} from '../../shared/utils/utils.service';
import { CampaignService } from '../campaign/campaign.service';
import { AlertService } from 'ng-jhipster';

@Component({
    selector: 'jhi-saisine-rejections',
    templateUrl: './saisine-rejections.component.html'
})
export class SaisineRejectionsComponent implements OnInit, AfterViewChecked {
    @Input() saisine: Saisine;

    @Output() saisineChange = new EventEmitter();

    saisineStatus = SaisineStatus;

    // Table rejections
    @ViewChild('dtRejections') dtRejections;
    initializedDtRejections: boolean;
    multiSortMetaDtRejections: any[];

    rejection: Rejection;

    isSaving: boolean;

    isSaisineFromMyRegion = false;


    constructor(
        private saisineService: SaisineService,
        private alertService: AlertService,
        private principal: Principal,
        public utilsService: UtilsService,
        public campaignService: CampaignService) {}

    ngOnInit() {
        this.rejection = new Rejection;
        this.initSortDtRejections();
        this.isSaisineFromMyRegion = this.principal.getAcademicRegionLabel() === this.saisine.licenceAcademicRegionLabel;
    }

    ngAfterViewChecked() {
        if (this.dtRejections && !this.initializedDtRejections) {
            // wait a tick to avoid one-time devMode
            // unidirectional-data-flow-violation error
            setTimeout(_ => this.utilsService.datatableInitFilters(this.dtRejections));
            this.initializedDtRejections = true;
        }
    }

    // Historique rejets
    initSortDtRejections() {
        this.multiSortMetaDtRejections = [];
        this.multiSortMetaDtRejections.push({field: 'date', order: -1});
    }



    rejectSaisine(saisineId: number) {
        this.isSaving = true;
        this.saisineService.addRejection(saisineId, this.rejection).subscribe(
            this.onSaveSuccess,
            this.onSaveError
        );
    }

    validSaisine(saisineId: number) {
        this.isSaving = true;
        this.saisineService.addValidation(saisineId).subscribe(
            this.onSaveSuccess,
            this.onSaveError
        );
    }
    cancelRejectSaisine(saisineId: number) {
        this.isSaving = true;
        this.saisineService.cancelRejection(saisineId).subscribe(
            this.onSaveSuccess,
            this.onSaveError
        );
    }

    cancelValidSaisine(saisineId: number) {
        this.isSaving = true;
        this.saisineService.cancelValidation(saisineId).subscribe(
            this.onSaveSuccess,
            this.onSaveError
        );
    }

    // this binding
    onSaveSuccess = () => {
        this.rejection = new Rejection;
        this.isSaving = false;
        this.saisineChange.emit();
    }

    // this binding
    onSaveError = (error) => {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-rejections.component.ts